import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { OrderTemplateSummaryEntity } from '../domains/entities/orderTemplate';
import { OrderTemplateAdapter } from '../adapters/orderTemplateAdapter';

/**
 * 発注テンプレート一覧を取得するユースケース
 */
export class GetOrderTemplateListUseCase {
  /**
   * コンストラクタ
   * @param repository - 発注テンプレートの取得を行うリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * テンプレート一覧を取得する
   */
  public Execute = async (): Promise<INetworkResult<OrderTemplateSummaryEntity[], IError>> => {
    const result = await this.repository.getList();
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: OrderTemplateAdapter.toSummaryEntities(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
